import React from "react";
import { Modal, Button } from "react-bootstrap";

const ViewMealModal = React.memo(({ show, onHide, meal, mealRecipes }) => {
  // Calculate totals for the meal
  const calculateTotals = () => {
    let totalCalories = 0;
    let totalPrice = 0;

    mealRecipes.forEach((recipe) => {
      if (recipe && !isNaN(recipe.total_calories) && !isNaN(recipe.servings) && recipe.servings !== 0) {
        const caloriesPerServing = Math.round(recipe.total_calories / recipe.servings);
        totalCalories += caloriesPerServing;
      }
      if (recipe && !isNaN(recipe.total_price) && !isNaN(recipe.meal_mutliplyer)) {
        totalPrice += recipe.total_price * recipe.meal_mutliplyer;
      }
    });

    return { totalCalories, totalPrice };
  };

  const totals = calculateTotals();

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Meal Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          <h4>{meal?.meal_name || "Meal"}</h4>
          {meal?.meal_notes && <p><strong>Notes:</strong> {meal.meal_notes}</p>}
          {meal?.meal_tags && <p><strong>Tags:</strong> {meal.meal_tags}</p>}
          
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Recipe</th>
                  <th className="text-center">Qty</th>
                  <th className="text-center">Course</th>
                  <th className="text-center">Servings</th>
                  <th className="text-center">Cal/Serv</th>
                  <th className="text-center">Price</th>
                </tr>
              </thead>
              <tbody>
                {mealRecipes.map((recipe, index) => {
                  const newMultiServings = Number.isInteger(recipe.servings * recipe.meal_mutliplyer)
                    ? (recipe.servings * recipe.meal_mutliplyer).toFixed(0)
                    : (recipe.servings * recipe.meal_mutliplyer).toFixed(1);

                  const caloriesPerServing = (!isNaN(recipe.total_calories) && !isNaN(recipe.servings) && recipe.servings !== 0)
                    ? Math.round(recipe.total_calories / recipe.servings)
                    : 0;

                  const formattedPrice = !isNaN(recipe.total_price)
                    ? `$${((recipe.total_price || 0) * recipe.meal_mutliplyer).toFixed(2)}`
                    : "$0.00";

                  return (
                    <tr key={index}>
                      <td><b>{recipe.name}</b></td>
                      <td className="text-center">{recipe.meal_mutliplyer}</td>
                      <td className="text-center">{recipe.course}</td>
                      <td className="text-center">{newMultiServings}</td>
                      <td className="text-center">{caloriesPerServing}</td>
                      <td className="text-center">{formattedPrice}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td><strong>Total</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-center"><strong>{totals.totalCalories}</strong></td>
                  <td className="text-center"><strong>${totals.totalPrice.toFixed(2)}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default ViewMealModal;